export const CART_ADD_ITEM = 'CART_ADD_ITEM';
export const CART_REMOVE_ITEM = 'CART_REMOVE_ITEM';
export const CART_REMOVE_ALL_ITEMS = 'CART_REMOVE_ALL_ITEMS';
export const CART_UPDATE_QUANTITIES = 'CART_UPDATE_QUANTITIES';

